export default {
    cz: {
        eshop: 'Kategorie e-shop',
        rental: 'Kategorie půjčovny',
    },
    sk: {
        eshop: 'Kategórie e-shop',
        rental: 'Kategórie pôžičovne',
    },
}
